import React from "react";
import { Box } from "@mui/material";
import ClientsTable from "../clientsTable";

/** El alta vive dentro de la barra de la tabla (ver ClientsTable). */
const ClientsScreen = () => (
  <Box sx={{ width: "100%" }}>
    <ClientsTable />
  </Box>
);

export default ClientsScreen;
